import { Delete, Get, Post, PostFormData } from "../Request/Api";

export default {
  state: {
    DownloadfileGroupsRecords: [],
    totalRecords: 0,
    Groups: [],
  },
  getters: {
    GetDownloadFileByGroups(state: any) {
      return state.DownloadfileGroupsRecords;
    },
    totalRecords(state: any) {
      return state.totalRecords;
    },
    GetGroups(state: any) {
      return state.Groups;
    },
  },
  actions: {
    async DownloadFile({ commit } :any, payload :any) {
      return await Get(`Download/DownloadFile/${payload}`).then((res) => {
        return res.data;
      });
    },
    async GetGroups({ commit }: any, payload: any) {
      return await Get(`Download/GetDownloadFileGroupByUserID/${payload}`).then((res: any) => {
        commit("SetGroups", res.data.Data);

        return res.data;
      });
    },
    async GetDownloadfiles({ commit }: any, payload: any) {
      return await Get("Download/GetDownloadFile").then((res: any) => {
        commit("SetDownloadfiles", res.data.Data);

        return res.data;
      });
    },
    async GetDownloadFileByGroups({ commit }: any, payload: any) {
      return await Get(
        `Download/GetDownloadFileByGroupByUserID/${payload.userId}?page=${
          payload.page
        }&pageSize=${10}&search=${payload.search}&filters=${payload.filters}`
      ).then((res: any) => {
        if (payload.page > 1) {
          commit("AppendDownloadfileGroups", res.data.Data);
        } else {
          commit("SetDownloadfileGroups", res.data.Data);
        }
        return res.data;
      });
    },
    ResetDownloadfileGroups({ commit }: any) {
      commit("ResetDownloadfileGroups");
    },
  },
  mutations: {
    SetDownloadfileGroups(state: any, payload: any) {
      state.DownloadfileGroupsRecords = payload.records;
      state.totalRecords = payload.totalRecords;
    },
    AppendDownloadfileGroups(state: any, payload: any) {
      // Append new records to existing ones (for pagination)
      state.DownloadfileGroupsRecords = [
        ...state.DownloadfileGroupsRecords,
        ...payload.records,
      ];
      state.totalRecords = payload.totalRecords;
    },
    SetGroups(state: any, payload: any) {
      state.Groups = payload;
    },
    ResetDownloadfileGroups(state: any) {
      state.DownloadfileGroupsRecords = [];
      state.totalRecords = 0;
    },
  },
};
